module.exports = __webpack_public_path__ + "img/carousel-2.a70b79e6.png";